(function () {
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isEditor = window.Shopify && window.Shopify.designMode;

  function markReady() {
    document.documentElement.classList.add('car-care-reveal-ready');
  }

  function revealAll() {
    document.querySelectorAll('.car-care-reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  if (prefersReduced || isEditor || !('IntersectionObserver' in window)) {
    markReady();
    revealAll();
    return;
  }

  markReady();

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      root: null,
      // Fires a bit before the element is fully in view (~12% up from the
      // bottom edge) so reveals feel responsive to scroll rather than lagging.
      rootMargin: '0px 0px -12% 0px',
      threshold: 0.1,
    }
  );

  function observeAll() {
    document.querySelectorAll('.car-care-reveal:not(.is-visible)').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAll);
  } else {
    observeAll();
  }

  // Re-scan when the theme editor swaps in a re-rendered section.
  document.addEventListener('shopify:section:load', observeAll);
})();
